import { FaSearch, FaTimes } from 'react-icons/fa';

const SearchInput = ({
  value,
  onChange,
  onClear,
  onKeyPress,
  placeholder = 'キーワードで検索',
  className = '',
  showIcon = true,
  showClearButton = true,
  disabled = false,
}) => {
  return (
    <div className={`relative ${className}`}>
      {showIcon && (
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 pointer-events-none">
          <FaSearch size={16} />
        </div>
      )}
      
      <input
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        disabled={disabled}
        className={`
          w-full px-4 py-2 border border-gray-300 rounded-lg
          focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
          disabled:bg-gray-100 disabled:cursor-not-allowed
          ${showIcon ? 'pl-10' : 'pl-4'}
          ${showClearButton && value ? 'pr-10' : 'pr-4'}
        `}
      />
      
      {showClearButton && value && !disabled && (
        <button
          type="button"
          onClick={() => {
            onChange('');
            if (onClear) onClear();
          }}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="検索クリア"
        >
          <FaTimes size={16} />
        </button>
      )}
    </div>
  );
};

export default SearchInput;
